import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { AuthorityDataService } from "../../core/authorities.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-authority",
    template: require('../shared/details-view.html')
})
export class Authority extends DetailsBase<Nema.Crew.Model.Authority> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('authority') authority: Nema.Crew.Model.Authority,
        @Inject('authorityDataService') authorityDataService: AuthorityDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, authority, authorityDataService, $log);
    }

    public entityName = "Authority";

    public editStateName = "app.settings.authorities.edit";

    public listStateName = "app.settings.authorities";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/authorities/authority.component.ts